import React, { FunctionComponent, useEffect, useState } from "react"
import { useHistory } from 'react-router-dom'
import { useMsal } from "@azure/msal-react"
import ServerStatus from "../../components/common/ServerStatus"
import appService from "src/AppService"
import I_AppState from "src/I_AppState"
import stateService from "src/utilities/AsyncStateManager/StateService"
import LoginBox from "./login_box/LoginBox"
import LoginLoader from "./login_loader/LoginLoader"
import "./Unautheticated.css"

const Unautheticated: FunctionComponent<{}> = () => {
    const history = useHistory()
    const { instance } = useMsal()
    const { authenticateWithPortalAPI } = appService
    const { updateState, manageSubscriptionAndStateUpdate } = stateService
    const [state, setState] = useState<I_AppState>(stateService.state.appState)
    const { loggingIn } = state

    const handleLogin = () => {
        try {
            const loginRequest = {
                scopes: [
                    process.env.REACT_APP_MSAL_INSTANCE_SCOPES as string
                ]
            }

            instance.loginPopup(loginRequest)
                .then(res => {
                    authenticateWithPortalAPI(res.accessToken, history)
                }).catch((err) => {
                    console.error(err)
                    localStorage.clear()
                    updateState("appState", [
                        { key: "authenticated", value: false },
                        { key: "loggingIn", value: false },
                    ])
                })
        } catch (err) {
            console.error(err)
            localStorage.clear()
            updateState("appState", [
                { key: "authenticated", value: false },
                { key: "loggingIn", value: false },
            ])
        }
    }

    useEffect(() => {

        const unsubscribe = manageSubscriptionAndStateUpdate(setState, "appState")

        return () => {
            unsubscribe()
        }
    }, [])

    return (
        <div className="Unautheticated">
            <div className="UnautheticatedHeader">
                <div className="UnautheticatedHeaderLeft">
                    <div className="UnautheticatedHeaderLogoWrapper">
                        <img id="e7c6ebada145e68e4209b1b821e231" src="/res/swoosh.png" alt="LaunchPoint" />
                    </div>
                    <div className="UnautheticatedHeaderTitleWrapper">
                        <p>LaunchPoint</p>
                    </div>
                    <div className="UnautheticatedHeaderServerStatusWrapper">
                        <ServerStatus />
                    </div>
                </div>
                <div className="UnautheticatedHeaderRight">
                    <span className="UnautheticatedHeaderButton" onClick={handleLogin}>Login</span>
                </div>
            </div>
            {!loggingIn &&
                <div className="UnautheticatedBody">
                    <LoginBox />
                </div>
            }
            {loggingIn && <LoginLoader />}
        </div>
    )
}

export default Unautheticated
